/**
 * Terminal queue-entry statuses — the entry is dead; nothing more will
 * happen to it (no further realtime transition, no path forward on that same
 * entry_id). Shared by QueueWaitingPage and QueueAssignedPage
 * (party-return-after-game fix) so a refresh landing on one of these NEVER
 * renders a stale waiting/assigned view — both pages navigate back to the
 * session hub instead, which surfaces the reopened party or the join CTA.
 */
const TERMINAL_QUEUE_ENTRY_STATUSES = new Set([
  "completed",
  "expired",
  "cancelled",
]);

export function isTerminalQueueEntryStatus(
  status: string | undefined,
): boolean {
  return status !== undefined && TERMINAL_QUEUE_ENTRY_STATUSES.has(status);
}
